import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.date.to-iso-string.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.number.parse-int.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
import HourPicker from 'integration-web-core--socle/js/assets/modules/_hourPicker.class.js';
export function formatAppointmentHours() {
  var today = new Date();
  var selectElement = document.querySelector('select[name="heureRdv"]');
  var datePicker = document.querySelector('input[name="dateRdv"]');

  // Creation of new hours array with value greater than current hour
  if (selectElement) {
    var newOptions = Array.prototype.filter.call(selectElement.options, function (option) {
      return Number.parseInt(option.value) > today.getHours();
    });

    // First item of the array
    var firstOpt = newOptions[0];

    // Lat item of the array
    var lastOpt = newOptions[newOptions.length - 1];
    initializeHourPicker(firstOpt.value, lastOpt.value, 60);
    if (datePicker) {
      datePicker.addEventListener('change', function (e) {
        var parts = e.target.value.split('/');
        var timestamp = parts.map(function (part) {
          return part.trim();
        });
        if (timestamp.length === 3) {
          // Sécurité supplémentaire : vérifier qu'on a bien 3 parties
          var newReservationDate = new Date(+timestamp[2], +timestamp[1] - 1, +timestamp[0]);
          if (newReservationDate.getDate() === today.getDate()) {
            initializeHourPicker(firstOpt.value, lastOpt.value, 60);
          } else {
            initializeHourPicker('09:00', '18:00', 60);
          }
        }
      });
    }
  }
}
export function formatDate(date) {
  return new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000 * -1).toISOString().split('T')[0];
}
function initializeHourPicker(minHour, maxHour, interval) {
  new HourPicker({
    element: 'select[name="heureRdv"]',
    hour: {
      start: minHour,
      end: maxHour,
      step: 1
    },
    minuteInterval: interval,
    showInterval: false,
    askForChoice: true
  });
}